import React from 'react';
import { NavLink } from 'react-router-dom';
// import { appAuth } from '../../services/auth';

import {
	Nav, Header, Team, About, Vision, Study, Areas,
	Contact, Location, Footer } from '../../components';

import inView from 'in-view';
// import luxy from 'luxy.js';

class LayoutPage extends React.Component {
	componentDidMount() {
		inView('.in_view_animate').on('enter', el => {
			el.classList.add('scrolled');
		});
	}
	render(){
		var { website } = this.props;
		return (
			<div>
				<Nav phone={website.phone} handleMenu={this.handleMenu} handleSection={this.handleSection} />
				<div id="luxy">
					<div data-step=".section__header">
						<Header phone={website.phone} title={website.title} image={website.headerImageId} subtitle={website.subtitle} handleSection={this.handleSection} />
						<About title={website.aboutTitle} images={website.websiteImage} description={website.about} />
						<Vision
							title={website.visionTitle}
							signature={website.signatureImageId}
							description={website.vision} name={website.signatureName} position={website.signaturePosition} />
					</div>
					<div data-step=".study">
						<Study
							image={website.studyImageId}
							title={website.studyTitle}
							description={website.study}
							text1={website.studyText1}
							text2={website.studyText2} />
						<Team users={website.user} title={website.userTitle} />
					</div>
					<div data-step=".wp-section-areas">
						<Areas areas={website.area} title={website.areaTitle} />
					</div>
					<div data-step=".contact">
						<Contact phone={website.phone} title={website.contactTitle} text={website.contactText} />
						<Location phone={website.phone} email={website.email} address={website.address} />
						<Footer />
					</div>
				</div>
			</div>
		);
	}
}

export default class Layout extends React.Component{
	scrollTo = ev => {
		var to = ev.currentTarget.getAttribute('data-to');
		var wrapper = document.querySelector(`.page-preview`);
		var el = wrapper.querySelector(to);
		var top = el.offsetTop - wrapper.scrollTop;
		wrapper.scrollBy({ top: top - 50, left: 0, behavior: 'smooth' });
	};

	render(){
		var { match, children, website, loading, saveChanges, onRestore, saving } = this.props;
		return (
			<div className="wp_admin">
				<div className="sidenav">
					<h2>ADMINWEB</h2>
					<div className="wp-menu">
						<ul>
							<li><NavLink onClick={this.scrollTo} data-to=".section__header" className="traf" to={`${match.url}/home`}>Inicio</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".about" className="traf" to={`${match.url}/about`}>Nosotros</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".vision" className="traf" to={`${match.url}/vision`}>Visión</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".study" className="traf" to={`${match.url}/study`}>Estudio</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".section__team" className="traf" to={`${match.url}/professional`}>Profesionales</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".wp-section-areas" className="traf" to={`${match.url}/areas`}>Áreas</NavLink></li>
							<li><NavLink onClick={this.scrollTo} data-to=".contact" className="traf" to={`${match.url}/contact`}>Contacto</NavLink></li>
						</ul>
					</div>
					<button onClick={saveChanges}>Guardar</button>
					{/* <button onClick={appAuth.signOut}>Salir</button> */}
					<button onClick={onRestore}>Restaurar</button>
				</div>
				<div className="page-preview">
					<LayoutPage website={website} />
				</div>
				<div className="section-form">
					<div>
						{loading ? <div>Loading...</div> : children}
					</div>
				</div>
				{ saving && <div className="saving"></div> }
			</div>
		);
	}
}
